





























































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {IDialog, PalletPattern, RobotTypeEnum} from '@/model'
import Units from '@/api/utils/units'
import { Overview3D } from '@/libs/overview3D'
import { Pallet3D } from '@/libs/pallet3D'
import CustomDataDialog from '@/components/CustomDataDialog.vue'
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'
import { CustomData } from '@/libs/palletPattern'
import { mapGetters } from 'vuex'
import { getLayerPatternNameFromValidationDetails } from '@/libs/pattern/layerPatternUtils'

@Component({
  components: {ConfirmDialog, CustomDataDialog},
  computed: {
    ...mapGetters('settings', ['isPatternValidationEnabled'])
  }
})
export default class PalletPatternDetails extends Vue {
  @Prop({ required: true }) private palletPattern!: PalletPattern
  @Prop() private units!: Units

  private view?: Pallet3D
  private overview3D!: Overview3D
  private isPatternValidationEnabled!: boolean
  private problematicLayerPattern!: string
  private showCustomDataDialog: boolean = false
  private palletPatternCopy = JSON.parse(JSON.stringify(this.palletPattern))
  private customData: CustomData[] = (this.palletPatternCopy.customData) ? Object.entries(this.palletPatternCopy.customData!).map(([key, value]) => ({
    key, value
  })) : []
  private showConfirmSaveDialog: boolean = false

  private confirmDialogProps: IDialog = {
    title: this.localText(''),
    text: this.localText('customData.saveCustomData'),
    cancelBtn: this.localText('general.cancel'),
    acceptBtn: this.localText('general.confirm')
  }

  get layersAmount () {
    return this.palletPattern.pallet!.layers!.length
  }

  get layers () {
    return this.palletPattern.pallet!.layerPatterns!.filter(p => p.boxPositions!.length > 0)
  }

  private localText (arg: string, values?: string[]): string {
    return String(this.$t(arg, values))
  }

  private created() {
    this.problematicLayerPattern = getLayerPatternNameFromValidationDetails(this.palletPattern)
  }

  private mounted () {
    this.view = new Pallet3D('pallet3d', this.palletPattern.box!, this.palletPattern.pallet!,
      this.palletPattern.programSettings!, 0xfafafa, { h: 550, w: 450 }, 0)
    this.view.batchLayers(true)
    this.overview3D = new Overview3D('canvas-overview', this.palletPattern.box!, this.palletPattern.pallet!,
        this.palletPattern.programSettings!)
    this.updateOverview()
  }

  private updateOverview() {
    let i = 0
    const start = 2600
    for (const layer of this.palletPattern.pallet!.layerPatterns!.filter(p => p.boxPositions!.length > 0)) {
      const idErrorBox = (this.problematicLayerPattern != null && layer.name === this.problematicLayerPattern) ? this.palletPattern.validationDetails!.lpbuId : undefined
      this.overview3D.addLayer(layer.boxPositions!, layer.boxPositionsAlt!, start - i, idErrorBox, layer.sequences)
      this.overview3D.setNumbers(layer.boxPositions!, layer.boxPositionsAlt!, start - i)
      i += 2600
    }
  }

  private showCustomData() {
    this.showCustomDataDialog = true
  }

  private translateUnit (unit: string): string {
    return String(this.$t('general.' + unit))
  }

  private translateConveyorConfig (conf: string): string {
    return String(this.$t('conveyorConfigEnums.' + conf))
  }

  private translateBoolean (conf: boolean): string {
    return String(this.$t('general.' + conf))
  }

  private async saveCustomData() {
    this.customData = Object.entries(this.palletPatternCopy!.customData!).map(([key, value]) => ({
      key, value
    }))
    const payload = {
      guid: this.palletPatternCopy.guid,
      palletPattern: JSON.parse(JSON.stringify(this.palletPatternCopy))
    }
    await this.$store.dispatch('palletpatterns/updatePalletPattern', payload)

    this.showCustomDataDialog = false
    this.showConfirmSaveDialog = false
  }

  private saveEmitted (obj: {}, skipConfirmDialog: boolean) {
    this.palletPatternCopy.customData = obj
    if (skipConfirmDialog) {
      this.saveCustomData()
    } else {
      this.showConfirmSaveDialog = true
    }
  }

  private getValidationStatus() {
    if (!this.palletPattern.validationStatus || this.palletPattern.validationStatus === 2) {
      return String(this.$t('patternList.validationStatus')) + String(this.$t('patternList.notValidated')).toUpperCase()
    }
    if (this.palletPattern.validationStatus === 1) {
      return String(this.$t('patternList.validationStatus')) + String(this.$t('patternList.valid')).toUpperCase()
    }
    if (this.palletPattern.validationStatus === 3) {
      return String(this.$t('patternList.validationStatus')) + String(this.$t('patternList.inValid')).toUpperCase() + ` - `
          + String(this.$t('patternList.invalidStatusDetails', [this.problematicLayerPattern, this.palletPattern.validationDetails!.layerNo]))
    }
  }

  @Watch ('palletPattern.validationStatus')
  private validationStatusWatcher(value: number) {
    this.problematicLayerPattern = getLayerPatternNameFromValidationDetails(this.palletPattern)
    this.updateOverview()
  }

  private getAlertType() {
    if (!this.palletPattern.validationStatus || this.palletPattern.validationStatus === 2) {
      return 'warning'
    }
    if (this.palletPattern.validationStatus === 1) {
      return 'success'
    }
    if (this.palletPattern.validationStatus === 3) {
      return 'error'
    }
  }

  private isCustomSolution() {
    return this.palletPattern.programSettings!.robotType === RobotTypeEnum.CUSTOM_SOLUTION
  }
}
